<template>
    <div class="ErrorBox">
        暂时还没有相关数据...
    </div>
</template>
<script>
export default {
    data(){
        return{
            ChatList:[{src:require('@/assets/tel.png'),txt:'400-026-9118'},{src:require('@/assets/qq.png'),txt:'3423898158'},{src:require('@/assets/mail.png'),txt:'sp@scwxkx.com'}]
        }
    }
}
</script>
<style lang="scss" scoped>
  .ErrorBox{
      padding: 10%  0;
      color:#cccccc;
      font-size: 15px;
      font-weight: 400;
  }
</style>